import { apiClient } from '../../utils';
import { handleError } from '../handleError';

export const createBlogPost = async ({ siteId, title, si, author }) => {
  try {
    const data = {
      site: siteId,
      title,
      si,
      ...(author ? { siteAuthor: author } : {}),
    };
    const rsp = await apiClient.post('/merchant/blog/create', {
      data,
    });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
